import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const NAVIGATION_ITEMS = [
  {
    title: 'Pisos',
    path: '/recubrimientos-pisos',
    submenu: [
      { title: 'Piso SPC Luxury', path: '/pisos-spc-premium', badge: 'Nuevo' },
      { title: 'Piso LVT Autoadherible', path: '/piso-vinilico-lvt-page' },
      { title: 'Piso Deck', path: '/piso-deck-sintetico-page' },
      { title: 'Tablones WPC', path: '/deck-tablon-wpc', badge: 'Nuevo' },
      { title: 'Piso de PVC', path: '/piso-de-pvc-rigido' },
      { title: 'Piso de Caucho', path: '/piso-de-caucho-page' },
    ],
  },
  {
    title: 'Muros y Techos',
    path: '/recubrimientos-muros',
    submenu: [
      { title: 'Follaje Artificial', path: '/follaje-artificial', badge: 'Nuevo' },
      { title: 'Muro Lambrin Cóncavo', path: '/muro-lambrin-concavo' },
      { title: 'Placa Tipo Mármol', path: '/muro-placa-tipo-marmol-page' },
      { title: 'Muro Lambrin', path: '/muro-lambrin-sintetico-page' },
      { title: 'Plafón Falso de PVC', path: '/techo-plafon-falso-page' },
      { title: 'Vigueta Wpc', path: '/vigueta-wpc-page' },
      { title: 'Muro Bamboo Espejo', path: '/muro-bamboo-espejo' },
    ],
  },
  {
    title: 'Hogar',
    path: '#!',
    submenu: [
      { title: 'Escritorios Escolares', path: '/escritorios-escolares' },
    ],
  },
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const location = useLocation();

  // Cerrar menú móvil al cambiar de ruta
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setOpenSubmenus({});
  }, [location.pathname]);

  // Manejar el redimensionamiento de pantalla
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setIsMobileMenuOpen(false);
        setOpenSubmenus({});
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const toggleSubmenu = (index, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenSubmenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <header className="header-style1 menu_area-light">
      <div className="navbar-default border-bottom border-color-light-white">
        <div className="container-fluid px-lg-1-6 px-xl-2-5 px-xxl-2-9">
          <div className="row align-items-center">
            <div className="col-12 col-lg-12">
              <div className="menu_area alt-font">
                <nav className="navbar navbar-expand-lg navbar-light p-0">
                  <div className="navbar-header navbar-header-custom">
                    <Link to="/" className="navbar-brand">
                      <img
                        id="logo"
                        src="/assets/img/logos/logo-inner.png"
                        alt="logo decototal"
                      />
                    </Link>
                  </div>

                  {/* Botón hamburguesa móvil */}
                  <div
                    className={`navbar-toggler bg-secondary ${isMobileMenuOpen ? 'menu-opened' : ''}`}
                    style={{ cursor: 'pointer' }}
                    onClick={toggleMobileMenu}
                    aria-label="Toggle navigation"
                  ></div>

                  {/* Menú de navegación */}
                  <ul
                    className={`navbar-nav ms-auto ${isMobileMenuOpen ? 'open' : ''}`}
                    id="nav"
                    style={{ display: isMobileMenuOpen ? 'block' : '' }}
                  >
                    {NAVIGATION_ITEMS.map((item, index) => {
                      const hasSub = Boolean(item.submenu && item.submenu.length > 0);
                      const isSubOpen = Boolean(openSubmenus[index]);

                      return (
                        <li
                          key={item.title}
                          className={`${hasSub ? 'has-sub' : ''} ${isSubOpen ? 'active' : ''}`}
                          style={{ position: 'relative' }}
                        >
                          {item.path === '#!' ? (
                            <a href="#!" onClick={(e) => hasSub && toggleSubmenu(index, e)}>
                              {item.title}
                            </a>
                          ) : (
                            <Link to={item.path}>{item.title}</Link>
                          )}

                          {hasSub && (
                            <>
                              <span
                                className="submenu-button d-lg-none"
                                onClick={(e) => toggleSubmenu(index, e)}
                                role="button"
                                tabIndex={0}
                                aria-label={`Submenú ${item.title}`}
                              />
                              <ul style={{ display: isSubOpen ? 'block' : '' }}>
                                {item.submenu.map((subItem) => (
                                  <li key={subItem.path}>
                                    <Link to={subItem.path}>
                                      {subItem.title}{' '}
                                      {subItem.badge && (
                                        <span className="menu-badge-new">
                                          {subItem.badge}
                                        </span>
                                      )}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                        </li>
                      );
                    })}

                    {/* Solo visible en móvil */}
                    <li className="d-lg-none">
                      <Link to="/calculadora-materiales">
                        Calculadora de Materiales
                      </Link>
                    </li>

                    {/* Contáctanos */}
                    <li>
                      <Link to="/contacto-decototal">Contáctanos</Link>
                    </li>
                  </ul>

                  {/* Botones de acción laterales */}
                  <div className="attr-nav align-items-xl-center ms-xl-auto main-font d-flex align-items-center gap-2">
                    {/* Botón Calculadora */}
                    <Link
                      to="/calculadora-materiales"
                      className="calc-btn d-none d-lg-inline-flex"
                      aria-label="Calculadora de Materiales"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="4" y="2" width="16" height="20" rx="2" />
                        <line x1="8" y1="6" x2="16" y2="6" />
                        <line x1="8" y1="10" x2="10" y2="10" />
                        <line x1="14" y1="10" x2="16" y2="10" />
                        <line x1="8" y1="14" x2="10" y2="14" />
                        <line x1="14" y1="14" x2="16" y2="14" />
                        <line x1="8" y1="18" x2="10" y2="18" />
                        <line x1="14" y1="18" x2="16" y2="18" />
                      </svg>
                      <span className="calc-btn-text">
                        <span>Calculadora de</span>
                        <span>Materiales</span>
                      </span>
                    </Link>

                    {/* Botón Cotiza Ahora */}
                    <ul className="mb-0">
                      <li className="d-none d-xl-inline-block">
                        <Link
                          to="/contacto-decototal"
                          className="butn-style4 md text-white"
                        >
                          <span>Cotiza Ahora</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;